const groupPrefix = createApiRoute(ApiModule.SYSTEM, ApiAuthorization.PUBLIC, ApiDataModel.SCHEDULE)

export const apiOperationSchedulePublic = {
	fetchOrderScheduleOperations: async (): Promise<IOrderScheduleOperationModel[]> => {
		const { data } = await apiCommon<IOrderScheduleOperation[]>(`${groupPrefix}`, { method: 'GET' })

		return data.map(d => OrderScheduleOperation(d))
	},

	getOperationScheduleEarliestAvailableDate: async () => {
		const { data } = await apiCommon<EOperationScheduleTypes>(`${groupPrefix}/earliest-available-date`, {
			method: 'GET',
		})
		return OperationScheduleType(data)
	},
}
